import NavBar from "../components/Navbar/NavBar"
import { Helper } from "../static/helper"
import Footer from "../components/Footer"
import ScrollToTop from '../components/ScrollToTop';

export const DeroulementSoins = () => {

    const webSite = () => {
        window.open(Helper.urlReservation)
    }

    return <>
        <div>
            <NavBar />
        </div>

        <ScrollToTop>

        <div className="min-h-screen bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 lg:pt-32 pb-12">

                <div className="text-center mb-10">
                    <h1 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-2xl sm:text-3xl lg:text-4xl mb-4">
                        Déroulement des soins
                    </h1>
                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4' style={{ borderColor: Helper.footerBackGroundColor }}></div>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

                    <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow duration-300">
                        <div className="flex items-center gap-3 mb-4">
                            <span className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg" style={{ background: Helper.footerBackGroundColor }}>1</span>
                            <h2 className="font-bold text-lg" style={{ color: Helper.footerBackGroundColor }}>Entretien individuel</h2>
                        </div>
                        <ul className="space-y-3 text-sm text-gray-600">
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Discussion sur vos antécédents médicaux et votre motif de consultation</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Analyse de vos examens complémentaires récents (radios, IRM, etc.)</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Explication de la chiropraxie et réponses à vos questions</span>
                            </li>
                        </ul>
                    </div>

                    <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow duration-300">
                        <div className="flex items-center gap-3 mb-4">
                            <span className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg" style={{ background: Helper.footerBackGroundColor }}>2</span>
                            <h2 className="font-bold text-lg" style={{ color: Helper.footerBackGroundColor }}>Examen clinique</h2>
                        </div>
                        <ul className="space-y-3 text-sm text-gray-600">
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Réalisation de tests pour évaluer votre posture et vos amplitudes de mouvements</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Identification des restrictions articulaires le long de la colonne vertébrale</span>
                            </li>
                        </ul>
                    </div>

                    <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow duration-300">
                        <div className="flex items-center gap-3 mb-4">
                            <span className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg" style={{ background: Helper.footerBackGroundColor }}>3</span>
                            <h2 className="font-bold text-lg" style={{ color: Helper.footerBackGroundColor }}>Bilan et objectifs</h2>
                        </div>
                        <ul className="space-y-3 text-sm text-gray-600">
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Présentation des résultats et explication des mécanismes liés à votre douleur</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Détermination des objectifs thérapeutiques</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Orientation éventuelle vers d'autres thérapeutes si nécessaire</span>
                            </li>
                        </ul>
                    </div>

                    <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow duration-300">
                        <div className="flex items-center gap-3 mb-4">
                            <span className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg" style={{ background: Helper.footerBackGroundColor }}>4</span>
                            <h2 className="font-bold text-lg" style={{ color: Helper.footerBackGroundColor }}>Ajustements</h2>
                        </div>
                        <ul className="space-y-3 text-sm text-gray-600">
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Mise en place des premiers soins</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Conseils et mise en place d'exercices personnalisés</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-green-500 mt-0.5">✓</span>
                                <span>Suivi de votre progression</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="flex justify-center mt-10">
                    <button style={{ background: Helper.footerBackGroundColor }} className="text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:opacity-90 transition-opacity" onClick={webSite}>
                        Prendre rendez-vous
                    </button>
                </div>

            </div>
        </div>

        <Footer />

        </ScrollToTop>
    </>
}
